import React, { useState } from 'react';
import Button from '../../../../../../../components/Button';
import EventProductListModal from './EventProductListModal';

interface EventProductListViewButtonProps {
  eventId: number;
}

const EventProductListViewButton = (props: EventProductListViewButtonProps) => {
  const { eventId } = props;
  const [isProductListModalOpen, setIsProductListModalOpen] = useState(false);

  return (
    <>
      <Button isRadius color="gray" text="상품 보기" onClick={() => setIsProductListModalOpen(true)} type="button" />
      {isProductListModalOpen && (
        <EventProductListModal eventId={eventId} onClose={() => setIsProductListModalOpen(false)} />
      )}
    </>
  );
};

export default EventProductListViewButton;
